export interface FreezeTooltipPluginOptions {
  id: string;
  canvasId: string;
  isFrozenRef: { current: boolean };
  hasSelectionRef: { current: any };
  getActiveElement: (chart: any) => any;
  withBeforeUpdate?: boolean;
  withAfterDraw?: boolean;
  drawOnAfterEvent?: boolean;
}

export function createFreezeTooltipPlugin(options: FreezeTooltipPluginOptions) {
  const { id, canvasId, isFrozenRef, hasSelectionRef, getActiveElement } = options;
  const withBeforeUpdate = options.withBeforeUpdate ?? false;
  const withAfterDraw = options.withAfterDraw ?? false;
  const drawOnAfterEvent = options.drawOnAfterEvent ?? false;

  const plugin: any = {
    id,
    afterEvent: function (chart: any) {
      if (chart.canvas?.id !== canvasId) return;
      if (!isFrozenRef.current || hasSelectionRef.current == null) return;
      try {
        const active = getActiveElement(chart);
        if (active) {
          (chart as any).tooltip._active = [active];
          (chart as any).tooltip.update(true);
          if (drawOnAfterEvent) chart.draw();
        }
      } catch {}
    },
  };

  if (withBeforeUpdate) {
    (plugin as any).beforeUpdate = function (chart: any) {
      if (chart.canvas?.id !== canvasId) return;
      if (!isFrozenRef.current || hasSelectionRef.current == null) return;
      try {
        const active = getActiveElement(chart);
        if (active) {
          (chart as any).tooltip._active = [active];
        }
      } catch {}
    };
  }

  if (withAfterDraw) {
    (plugin as any).afterDraw = function (chart: any) {
      if (chart.canvas?.id !== canvasId) return;
      if (!isFrozenRef.current || hasSelectionRef.current == null) return;
      try {
        const active = getActiveElement(chart);
        if (active) {
          (chart as any).tooltip._active = [active];
          (chart as any).tooltip.update(true);
          (chart as any).tooltip.draw();
        }
      } catch {}
    };
  }

  return plugin;
}
